import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { seoMeta, canonicalLink } from "@/lib/content-defaults";
import { Route as rootRoute } from "./__root";

// El contenido real vive en nosotros-page.tsx y se descarga aparte (code-split) — así visitar
// el home u otra página pública no baja el bundle de esta (ver mismo criterio en staff.tsx).
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/nosotros",
  head: () => ({
    meta: seoMeta({
      title: "Entrenadores de Calistenia — Calistenia Progresiva",
      description: "Conoce al equipo de entrenadores de calistenia detrás del método: el profesor Joche y el resto del equipo CP.",
      path: "/nosotros",
    }),
    links: [canonicalLink("/nosotros")],
  }),
  component: lazyRouteComponent(() => import("./nosotros-page"), "NosotrosPage"),
});
